<template>
    <div>
        <el-dialog
                :title="$t(`PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB0`)"
                visible
                width="35%"
                @close="onCancel">
            <el-row>
                <el-col :span="8" class="label-class">
                    {{ $t('recevier')}}:
                </el-col>
                <el-col :span="15">
                    <el-select v-model="emailList" filterable multiple value-key="id" :placeholder="$t('COMMON_SELECT')" collapse-tags>
                        <el-option
                                v-for="item in emailOptions"
                                :key="item.id"
                                :label="item.userName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="8" class="label-class">
                    {{ $t('ccer')}}:
                </el-col>
                <el-col :span="15">
                    <el-select v-model="cc" filterable multiple value-key="id" :placeholder="$t('COMMON_SELECT')" collapse-tags>
                        <el-option
                                v-for="item in ccOptions"
                                :key="item.id"
                                :label="item.userName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <span slot="footer" class="dialog-footer">
              <el-button class="cancel-btn" @click="onCancel">{{ $t('comment_reSet') }}</el-button>
              <el-button class="cancel-btn" @click="onConfirm(true)">{{ $t('send_me_a_preview') }}</el-button>
              <el-button type="primary" class="wl-green" @click="onConfirm(false)">{{ $t('comment_send') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import API from '@/api'
    export default {
        name: "exchange-email",
        props: {
            onAdd: Function,
            onCancel: Function,
        },
        data(){
            return {
                emailList: [],
                emailOptions: [],
                ccOptions: [],
                cc: []
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite',
            })
        },
        mounted() {
            this.getOptions()
        },
        methods: {
            async getOptions(){
                const {code,data} = await API.exchange.queryClientUserList({siteId: this.getSite.siteId})
                this.emailOptions = []
                if(code == '1'){
                    data.forEach(item => {
                        this.emailOptions.push({id: item.id, email: item.userAccount, userName: item.userName})
                    })
                }else{
                    this.$message.error(this.$t(code))
                }
                API.status.queryKPMemberBySite({ siteId: this.getSite.siteId,userType: '1' }).then(res => {
                    this.ccOptions = res.data
                })
            },
            onConfirm(myself = false){
                if(myself || this.emailList.length != 0){
                    this.onAdd(
                        myself ? ['myself'] : this.emailList, 
                        myself ? [] : this.cc
                    )
                } else {
                    this.$message.error(this.$t('please_choose_recevier'))
                }
            }
        }
    }
</script>

<style scoped>
.label-class{
    text-align: left;
    height: 32px;
    line-height: 32px;
    margin-right: 10px;
}
::v-deep .el-input{
    width: 320px;
}
</style>